<template>
  <div class="Banner">
    <div class="Banner_content" :class="[terminal == 'pc'?'pcBanner':'phoneBanner']">
      <div class="Banner_content_test" >
        <InputCom></InputCom>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMixin } from "@/util/mixin";
export default {
  mixins: [mapMixin],
  components:{
     InputCom: () => import("./Input.vue")
  }
 
};
</script>

<style lang="scss" scoped>
@media screen and (min-width: 1026px) {
.Banner {
  overflow: hidden;
  width: 100%;
  height: 360px;
  position: relative;
  object-fit: cover;
  background-attachment: fixed;
  background: url("../../../assets/image/DataSearch/bg.png") no-repeat;
  background-size: cover;
    // margin-top: 72px;
    top: 0;
  .Banner_content {
    width: 1200px;
    height: 120px;
    margin: auto ;

    .Banner_content_test {
           margin-top: 130px;
      height: 100%;
      width: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;

      p {
        color: #fff;
        font-size: 36px;
        font-weight: 600;
      }
      .test {
        margin-top: 20px;
        color: #fff;
        font-size: 16px;
      }
    }
  }
}
}
@media screen and (min-width: 768px) and (max-width: 1025px) {
  .Banner {
  width: 100%;
  height: 300px;
  position: relative;
  object-fit: cover;
  background-attachment: fixed;
  background: url("../../../assets/image/DataHub/bg.png") no-repeat;
  background-size: 100% 100%;
    // margin-top: 72px;
  .Banner_content {
    width: 1200px;
    height: 300px;
    margin: auto ;

    .Banner_content_test {
 
      height: 300px;
      width: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;

      p {
        color: #fff;
        font-size: 36px;
        font-weight: 600;
      }
      .test {
        margin-top: 20px;
        color: #fff;
        font-size: 16px;
      }
    }
  }
}
}
@media screen and (max-width: 767px) {
  .phoneBanner{
    height: 80px !important;
  }
 
    .Banner {
  width: 100%;
  // height: 300px;
  position: relative;
  object-fit: cover;
  background-attachment: fixed;
  background: url("../../../assets/image/DataHub/bg.png") no-repeat;
  background-size: cover;
    // margin-top: 72px;
  .Banner_content {
    width: 100%;
    height: 100%;
    margin: 60px auto ;

    .Banner_content_test {
      height: 100%;
      width: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;

      p {
        color: #fff;
        font-size: 36px;
        font-weight: 600;
      }
      .test {
        margin-top: 20px;
        color: #fff;
        font-size: 16px;
      }
    }
  }
}
}
</style>